/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_So_Tien_ExInputs */

const vi_station_voice_ph_so_tien_ex = /** @type {(inputs: Station_Voice_Ph_So_Tien_ExInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50000 đọc thành năm mươi nghìn`)
};

/**

* @param {Station_Voice_Ph_So_Tien_ExInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_so_tien_ex = /** @type {((inputs?: Station_Voice_Ph_So_Tien_ExInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_So_Tien_ExInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_so_tien_ex(inputs)
});